<script lang="ts" setup name="SailingScheduleTradeLaneHeading"></script>

<template>
  <div class="h-16 bg-charcoal-1 px-4 font-bold text-charcoal-8">
    <slot />
  </div>
</template>
